import { useEffect } from 'react';
import {
  BooleanNode,
  DefaultNodeOptions,
  widget,
  WidgetPlugin,
} from '@sagold/react-json-editor';

import { Checkbox } from '../../../components/checkbox/Checkbox';
import { FormField } from '../../../components/formfield/FormField';

export type BooleanOptions = DefaultNodeOptions;

export const BooleanWidget = widget<BooleanNode<BooleanOptions>, boolean>(
  ({ node, options, setValue }) => {
    const hasError = node.errors.length > 0;
    const isValidConst = node.schema.const != null && !hasError;

    /* Make sure null data is treated as false and doesn't create an
     * "Input is required" error */
    useEffect(() => {
      if (node.value == null) {
        setValue(false);
      }
    }, [node, setValue]);

    return (
      <FormField widgetType="checkbox" node={node} options={options}>
        <Checkbox
          // Workaround: Do not update data when readonly option is set. Needed, because the Mantine Checkbox still
          // allows to change the value despite readOnly is set
          onChange={(data) => !options.readOnly && setValue(data)}
          disabled={options.disabled}
          required={options.required}
          readOnly={options.readOnly}
          error={isValidConst}
          checked={node.value}
          label={options.title}
        />
      </FormField>
    );
  }
);

export const BooleanWidgetPlugin: WidgetPlugin = {
  id: 'boolean-widget',
  use: (node) => node.schema.type === 'boolean',
  Widget: BooleanWidget,
};
